import { type IPickable, type IPickableRegistry } from '@/engine/app/interfaces';
import type { IHandlerDescriptor, IPointerController } from './PointerController';
import type { PointerSyntheticEvent } from './PointerSyntheticEvent';
import type { ObservabilityLoggerService } from '@/app.obresvability/loggerService/observabilityLogger.service.ts';
import type { IPickablesSelector } from './PickablesSelector';
import { type IPickObjectManager as IObjectPickerController } from './pointerHandlerPickObject/types';
import { PointerHandlerAdapter } from '@/engine/app/modules/pointerStack/PointerHandlerComposite';

export class PickObjectMouseAdapter extends PointerHandlerAdapter<IObjectPickerController> {
  public onPointerMove(event: PointerSyntheticEvent): void {
    this._controller?.updatePickable(event);
  }

  public onPointerLeave(): void {
    this._controller?.removePickedHandlerDescriptor();
  }

  public setParent(ctrl: IPointerController): void {
    this._controller?.setPointerController(ctrl);
  }

  public reset(): void {
    // do nothing
  }
}

export class PickObjectTouchAdapter extends PointerHandlerAdapter<IObjectPickerController> {
  public onPointerEnter(event: PointerSyntheticEvent): void {
    this._controller?.updatePickable(event);
  }

  public onPointerMove(event: PointerSyntheticEvent): void {
    this._controller?.updatePickable(event);
  }

  public onPointerLeave(event: PointerSyntheticEvent): void {
    this._controller?.updatePickable(event);
  }

  public setParent(ctrl: IPointerController): void {
    this._controller?.setPointerController(ctrl);
  }

  public reset(): void {
    // do nothing
  }
}

export class ObjectPickerController implements IObjectPickerController {
  // TODO: check logging
  private readonly _loggerService: ObservabilityLoggerService;

  private readonly _viewPortDescriptor: string;

  private _pointerController?: IPointerController;

  private _pickableRegistry: IPickableRegistry;

  private _pickableSelector: IPickablesSelector;

  private _picked: IPickable | undefined;

  private _pickedHandlerDescriptor: IHandlerDescriptor | undefined;

  public constructor(
    pickableRegistry: IPickableRegistry,
    loggerService: ObservabilityLoggerService,
    viewPortDescriptor: string,
    pickableSelector: IPickablesSelector
  ) {
    this._pickableRegistry = pickableRegistry;
    this._loggerService = loggerService;
    this._viewPortDescriptor = viewPortDescriptor;
    this._pickableSelector = pickableSelector;
  }

  public setPointerController(pointerController: IPointerController): void {
    this._pointerController = pointerController;
  }

  private _getPicked(event: PointerSyntheticEvent): IPickable | undefined {
    const pickables = this._pickableRegistry.getPickables();
    const selectedPickable = this._pickableSelector.getPicked(pickables, event);
    return selectedPickable;
  }

  public removePickedHandlerDescriptor(): void {
    if (this._pickedHandlerDescriptor) {
      this._pickedHandlerDescriptor.remove();
      this._pickedHandlerDescriptor = undefined;
    }
  }

  public updatePickable(event: PointerSyntheticEvent): void {
    const picked = this._getPicked(event);
    if (this._picked === picked) return;
    this.removePickedHandlerDescriptor();

    this._picked?.onUnPicked(this._pointerController);
    this._picked = picked;

    if (this._picked) {
      const handler = this._picked.onPicked(event, this._pointerController);
      if (handler) {
        this._pickedHandlerDescriptor = this._pointerController?.pushPointerHandler(handler);
      }
    }
  }
}
